import React from 'react';

const WhyChooseUs = () => {
  return (
    <div className="section-full site-bg-white twm-w-chooseus-section-wrap wow fadeInDown pt-0" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container">
        <div className="row twm-w-chooseus-section">
          <div className="col-lg-5 col-md-12">
            {/* TITLE START */}
            <div className="section-head left">
              <div className="twm-sm-title left">Our Features</div>
              <h2 className="twm-large-title site-text-dark">Why Choose Us?</h2>
              <div className="section-head-detail">
              At AB Ghule Cabs, we offer a world of convenience, safety, and personalized solutions, ensuring your journey is memorable and stress-free. Whether you're traveling for business or leisure, our tailored services pave the way for unforgettable adventures and seamless mobility. Trust us to be your reliable travel companion!
              </div>
            </div>
            {/* TITLE END */}

            <div className="twm-list-icon-style1">
              <ul>
                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="images/w-choose-icon/icon-1.png" alt="Deals For Every Budget" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Deals For Every Budget</h3>
                      <p>At AB Ghule Cabs, we offer incredible rates on every car, van, bike, and package, ensuring you travel with comfort and affordability.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="images/w-choose-icon/icon-2.png" alt="Flexible Pricing" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Flexible Pricing</h3>
                      <p>At AB Ghule Cabs, we offer tailored solutions to meet your travel needs, paving the way for unforgettable adventures and seamless mobility. </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="images/w-choose-icon/icon-3.png" alt="Quality At Minimum Expense" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Quality At Minimum Expense</h3>
                      <p>At AB Ghule Cabs, we offer customized travel solutions designed to provide unforgettable adventures and seamless mobility. </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <span>
                        <img src="images/w-choose-icon/icon-4.png" alt="Free Pick-Up & Drop-Off" />
                      </span>
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Free Pick-Up & Drop-Off</h3>
                      <p>Enjoy the convenience of free pickup and drop-off services with AB Ghule Cabs, adding an extra layer of ease to your car rental experience. </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <div className="twm-w-chooseus-media">
              <div className="twm-media">
                <img src="/images/about/car2.png" alt="Need Help" />
              </div>
              <div className="twm-need-help-bx">
                <div className="twm-need-help-content">
                  <span>Need any help ?</span>
                  <h3 className="twm-title">+91 8624029699</h3>
                </div>
                <div className="twm-need-help-icon">
                  <img src="images/24-clock.png" alt="24/7 support" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
